module.exports = __webpack_public_path__ + "static/media/user-alien.58d049e2.svg";